import { useState } from "react";

const ContactUsInput = ({ icon, label, type, value, buildMessage }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div className="flex flex-col relative space-y-2">
      <label
        className={`text-primary opacity-70 capitalize ${
          !isFocused && value.trim().length === 0 ? "absolute top-3 left-6" : ""
        }`}
        htmlFor={label}
      >
        {label}
      </label>
      {type !== "textArea" && (
        <input
          className="border-b focus:outline-none focus:border-primary p-1 px-6"
          id={label?.replace(" ", "-")}
          type={type}
          required
          value={value}
          onChange={(e) => buildMessage(e.target.value)}
          autoComplete="off"
          onFocus={(_) => setIsFocused(true)}
          onBlur={(_) => setIsFocused(false)}
        />
      )}
      {type === "textArea" && (
        <textarea
          value={value}
          onChange={(e) => buildMessage(e.target.value)}
          className="focus:outline-none border-b p-1 px-6 focus:border-primary"
          id={label?.replace(" ", "-")}
          onFocus={(_) => setIsFocused(true)}
          onBlur={(_) => setIsFocused(false)}
        ></textarea>
      )}
      <div
        className={`absolute text-primary ${
          !isFocused && value.trim().length === 0 ? "top-2" : "top-8"
        }`}
      >
        {icon}
      </div>
      <div
        className={`absolute text-red-400 right-0 ${
          !isFocused && value.trim().length === 0 ? "top-2" : "top-8"
        }`}
      >
        *
      </div>
    </div>
  );
};

export default ContactUsInput;
